<template>
  <resumo-padrao ref="resumo" resumo-proposta></resumo-padrao>
</template>
<script>
export default {
  props: {
    value: null,
  },
  computed: {
    isentarIOF () {
      return this.$api.Estruturadas.isNotaComercial(this.value.TipoContratoSigla)
    }
  },
  methods: {
    load: async function () {
      const th = this
      if (th.value.TipoCalculoFluxo === th.$aux.TipoFluxoEnum.Irregular) {
        const { PMTIrregular: { Resumo } } = await th.$api.Estruturadas.CalcularFluxoIrregular(th, th.value.dtoFluxoIrregular)
        return th.setModel({ Proposta: Resumo })
      }
      const dto = {
        codigoProposta: th.value.Codigo,
        usarJurosProposta: true,
        calculoGradesParcelas: true,
        montaFluxoPagamentoEstatico: true,
      }
      const method = th.value.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC ? 'CalcularCamposPropostaSAC' : 'CalcularCamposProposta'
      th.$api.Multiplo.Post(method, { dto }).then(
        (result) => {
          th.setModel(result)
        }
      );
    },
    async setModel (result) {
      const th = this
      const IOF_NOTA = 0.001
      var proposta = {
        ...th.value,
        ...result.Proposta
      }
      if (th.isentarIOF && !Number.isInteger(result.Proposta.VlrTotalCredito)) {
        th.model = proposta
        await th.$api.Estruturadas.RoundNotaComercial(th)
        proposta.VlrTAC = th.model.VlrTAC
      }

      let valorSolicitado = proposta.TipoOperacaoCred === 3 ? (proposta.VlrProdutoBem - proposta.VlrEntrada) : proposta.VlrSolicitado
      let valorTotalSolicitado = (proposta.VlrSolicitado || 0)
      if (proposta.TipoOperacaoCred === 3) { valorTotalSolicitado = (proposta.VlrProdutoBem || 0) - (proposta.VlrEntrada || 0) }
      if (th.value.ModeloCalculo === th.$aux.ModeloCalculoEnum.SAC) {
        valorSolicitado += (proposta.VlrITBI || 0) + (proposta.VlrRegistroImovel || 0) + (proposta.VlrRegistroGarantia || 0)
        valorTotalSolicitado += (proposta.VlrITBI || 0) + (proposta.VlrRegistroImovel || 0) + (proposta.VlrRegistroGarantia || 0)
      }
      valorTotalSolicitado += (proposta.VlrTAC || 0)

      if (proposta.OutrosServicos) { valorTotalSolicitado += (proposta.VlrSeguro || 0) + (proposta.VlrAvaliacao || 0) + (proposta.VlrVistoria || 0) }

      var parcelas = proposta.Parcelas.filter(parcela => parcela.Parcela !== 0)
      const model = {
        Codigo: proposta.Codigo,
        Situacao: proposta.Situacao,
        SituacaoDescricao: proposta.SituacaoDescricao,
        CodigoCliente: proposta.CodigoCliente,

        Cliente: {
          ...proposta.Cliente,
        },
        TipoOperacaoCred: proposta.TipoOperacaoCred,
        TipoOperacaoNome: proposta.TipoOperacaoNome,
        TipoContratoDescricao: proposta.TipoContratoDescricao,
        TipoCalculoFluxo: th.value.TipoCalculoFluxo,
        PrimeiraParcela: parcelas[0],
        UltimaParcela: parcelas[parcelas.length - 1],
        Prazo: proposta.Prazo,

        VlrSolicitado: valorSolicitado,
        VlrTAC: proposta.VlrTAC,
        VlrTotalSolicitado: valorTotalSolicitado,
        VlrIOF: th.isentarIOF ? IOF_NOTA : (proposta.VlrIOF || proposta.IOF),
        VlrTotalFinanciado: (proposta.VlrIOF || 0) + valorTotalSolicitado,
        VlrTotalDivida: proposta.VlrTotalDivida,

        OutrosServicos: proposta.OutrosServicos,
        VlrSeguro: proposta.VlrSeguro,
        VlrAvaliacao: proposta.VlrAvaliacao,
        VlrVistoria: proposta.VlrVistoria,
        VlrRegistro: proposta.VlrRegistro,

        PercIndiceFinan: proposta.PercIndiceFinan,
        PercJurosMensal: result.Proposta.PercJurosMensal || result.Proposta.TxJurosAoMes,
        PercJurosAnual: result.Proposta.PercJurosAnual || result.Proposta.TxJurosAoAno,
        PercCETMensal: result.Proposta.PercCETMensal || result.Proposta.CETaoMes,
        PercCETAnual: result.Proposta.PercCETAnual || result.Proposta.CETaoAno,
        ModeloCalculo: proposta.ModeloCalculo,
        TipoIndexador: proposta.TipoIndexador,
        TipoIndiceFinan: proposta.TipoIndiceFinan,

        Parcelas: parcelas,

        VlrTxAdmMensal: proposta.VlrTxAdmMensal,
        VlrITBI: proposta.VlrITBI,
        PercSeguroMensal1: proposta.PercSeguroMensal1,
        VlrSeguroMensal1: proposta.VlrSeguroMensal1,
        PercSeguroMensal2: proposta.PercSeguroMensal2,
        VlrSeguroMensal2: proposta.VlrSeguroMensal2
      }
      th.$refs.resumo.load(model)
    }
  }
}

</script>
